<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="row mt-3">
                <app-ag-grid-wrapper #grid [gridConfig]='gridOptions' [rowData]="rowData" [columnDefs]="columnDefs"
                    [frameworkComponents]='frameworkComponents' [context]='context' (gridReady)="onGridReady()">
                </app-ag-grid-wrapper>
            </div>
        </div>
    </div>
